module.exports = __webpack_public_path__ + "static/media/day24.workshop.cc9a1ee8.md";